'use strict';

(function ($) {
  var methods = {
    init: function (options)  {
      var opts = $.extend({}, $.fn.k2_onscreenInput.defaults, options);

      return this.each(function () {
        var $this = $(this);
        var _this = this;
        var deactivateFn = $.debounce.apply(_this, [methods.deactivate, opts.timeout]);
        var $element = $('<div class="onscreen-input"></div>');

        $this.data('onscreen-input-active', false);
        $this.data('onscreen-input-opts', opts);
        $this.data('onscreen-input-element', $element);

        $this.on('keypress', function (e) {
          if ($('[data-onscreen-input]').length === 0 || ['INPUT', 'TEXTAREA'].indexOf(e.target.tagName) > -1 || e.originalEvent.altKey || e.originalEvent.ctrlKey || e.originalEvent.metaKey || e.originalEvent.charCode === 0) {
            return true;
          }

          return methods.handleKeypress.apply(_this, [e, deactivateFn]);
        });

      });

    },

    activate: function () {
      var $this = $(this);

      $this.data('onscreen-input-active', true);
      $this.data('onscreen-input-value', '');
      $this.data('onscreen-input-element');
      $this.append($this.data('onscreen-input-element'));
    },

    deactivate: function () {
      var $this = $(this);
      var _this = this;
      var el = $('[data-onscreen-input]').first();

      $this.data('onscreen-input-active', false);
      $this.data('onscreen-input-element').remove();
      el.val($this.data('onscreen-input-value'));
      el.focus();
      $this.data('onscreen-input-opts').afterChange.apply(_this, [el]);
    },

    handleKeypress: function (e, callback) {
      var $this = $(this);
      var _this = this;
      var keyCode = e.originalEvent.keyCode || e.originalEvent.which || e.originalEvent.charCode || e.originalEvent.code;
      var key = e.originalEvent.key || keyCode;

      if (keyCode < ' '.charCodeAt(0)) {
        return true;
      }

      if (typeof key === 'number') {
        key = String.fromCharCode(key);
      }

      if (!$this.data('onscreen-input-active')) {
        methods.activate.apply(_this);
      }

      $this.data('onscreen-input-value', $this.data('onscreen-input-value') + key);
      $this.data('onscreen-input-element').text($this.data('onscreen-input-value'));
      callback.apply(_this);

      return false;
    }

  };

  $.fn.k2_onscreenInput = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_onscreenInput');
    }

  };

  $.fn.k2_onscreenInput.defaults = {
    timeout: 400,
    afterChange: function () {
      return true;
    },

  };

})(jQuery);
